var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipe11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 351,
    height: 165,
    viewBox: "0 0 351 165",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_65)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 44.8878C45.5 50.1345 49.753 54.3878 55 54.3878H296C326.099 54.3878 350.5 78.7882 350.5 108.888L350.5 165H305.5V108.888C305.5 103.641 301.247 99.3878 296 99.3878H55C24.9 99.3878 0.5 74.9873 0.5 44.8877V-3.05176e-05L45.5 -1.32918e-05V44.8878Z",
    fill: "#BED4ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5067 56.589L42.9763 39.792H4.03711L23.5067 56.589Z",
    fill: "url(#paint0_linear_12_65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4881 43.193L42.9577 26.396H4.0186L23.4881 43.193Z",
    fill: "url(#paint1_linear_12_65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4696 29.797L42.9391 13H4.00001L23.4696 29.797Z",
    fill: "url(#paint2_linear_12_65)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_65",
    x1: 23.5067,
    y1: 56.589,
    x2: 23.5067,
    y2: 34.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_65",
    x1: 23.4881,
    y1: 43.193,
    x2: 23.4881,
    y2: 20.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_65",
    x1: 23.4696,
    y1: 29.797,
    x2: 23.4696,
    y2: 7.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 351,
    height: 165,
    fill: "white",
    transform: "matrix(-1 0 0 1 351 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe11);
export default __webpack_public_path__ + "static/media/pipe-11.c9fd7b7097efcf08b0061d72d425962c.svg";
export { ForwardRef as ReactComponent };